import React, { useEffect, useState } from "react";
import DialogWrapMedium from "../../../controls/components/dialogWrap/DialogWrap";
import { TextField } from "@material-ui/core";
import {
    InputOrderAdminTitle,
    UserFormServiceButtonClose,
    UserFormServiceButtonCreated,
} from "../../MyBooking/styled/DesStyled";
import usePartnerDetail from "../hook/useGetUserDetail";
import http from "../../../../services/http";

type FeatureInput = { title: string; text: string };

export default function DialogFeaturesPartner(props: {
    openDialog: boolean;
    setOpenDialog: (value: boolean) => void;
    partnerId: string;
    reload: () => void;
}) {
    const { userDetail } = usePartnerDetail({ id: props.partnerId, openDialog: props.openDialog });
    const [features, setFeatures] = useState<FeatureInput[]>([
        { title: "", text: "" },
        { title: "", text: "" },
        { title: "", text: "" },
    ]);

    useEffect(() => {
        if (props.openDialog && userDetail) {
            const partnerFeatures = (userDetail as any).features as FeatureInput[] | undefined;
            if (partnerFeatures && Array.isArray(partnerFeatures) && partnerFeatures.length > 0) {
                const normalized: FeatureInput[] = [0, 1, 2].map((i) => ({
                    title: partnerFeatures[i]?.title || "",
                    text: partnerFeatures[i]?.text || "",
                }));
                setFeatures(normalized);
            } else {
                setFeatures([
                    { title: "", text: "" },
                    { title: "", text: "" },
                    { title: "", text: "" },
                ]);
            }
        }
    }, [userDetail, props.openDialog]);

    const handleChange = (index: number, key: keyof FeatureInput, value: string) => {
        const newItems = [...features];
        newItems[index] = { ...newItems[index], [key]: value } as FeatureInput;
        setFeatures(newItems);
    };

    const handleSave = async () => {
        try {
            await http.put(`/admin-update-partner-features/${props.partnerId}`, {
                features: features,
            });
            props.reload();
            props.setOpenDialog(false);
        } catch (err) {
            console.error("Error updating features:", err);
        }
    };

    return (
        <DialogWrapMedium
            login={true}
            open={props.openDialog}
            onClose={() => props.setOpenDialog(false)}
            title="Manage Process Steps"
            actions={
                <>
                    <UserFormServiceButtonClose onClick={() => props.setOpenDialog(false)}>
                        Cancel
                    </UserFormServiceButtonClose>
                    <UserFormServiceButtonCreated onClick={handleSave}>Save</UserFormServiceButtonCreated>
                </>
            }>
            <div>
                <div style={{ marginBottom: "12px" }}>
                    <InputOrderAdminTitle>Configure 3 steps (title + text)</InputOrderAdminTitle>
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: 16 }}>
                    {[0, 1, 2].map((i) => (
                        <div key={i} style={{ border: "1px solid #e0e0e0", borderRadius: 8, padding: 16 }}>
                            <TextField
                                label={`Step ${i + 1} Title`}
                                variant="outlined"
                                fullWidth
                                style={{ marginBottom: 12 }}
                                value={features[i]?.title || ""}
                                onChange={(e) => handleChange(i, "title", e.target.value)}
                                placeholder="e.g., Book bag storage in a tap"
                            />
                            <TextField
                                label={`Step ${i + 1} Text`}
                                variant="outlined"
                                fullWidth
                                multiline
                                rows={2}
                                value={features[i]?.text || ""}
                                onChange={(e) => handleChange(i, "text", e.target.value)}
                                placeholder="e.g., Choose how long you need luggage storage and book online"
                            />
                        </div>
                    ))}
                </div>
            </div>
        </DialogWrapMedium>
    );
}


